import React from 'react'
import { MobileDesktopWrapper } from 'src/mobile/mobile-wrapper/mobile-wrapper.component.js'

export default class MfaAccessAuthorized extends React.PureComponent {
  render() {
    const { mobile, mfaOtherDeviceData} = this.props
    const {location, device} = mfaOtherDeviceData || {};
    return <MobileDesktopWrapper image="https://cdn.canopytax.com/static/login-ui/devices.svg" mobile={mobile}>
      <div>
        <div className="cps-padding-bottom-16">
          You have successfully authorized the other device{location && <span> near {location}</span>}.  To access your account, please use that device. 
        </div>
        { device &&
          <div className="cps-padding-bottom-8">
            Device: {device}
          </div>
        }
        { location && 
          <div className="cps-padding-bottom-8">
            Location: {location}
          </div>
        }
      </div>
    </MobileDesktopWrapper>
  }
}
